/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { BlogType } from "../../types/blog";
import {
  formatToEasternTime,
  formatToET,
} from "../../components/utils/formatToET";
import { getBlogCategories, getBlogs } from "../../services/firebase";
import StyledLoadingSpinner from "../../components/ui/StyledLoadingSpinner";
import AdUnit from "../../components/utils/adUnit";

const BlogDetailsSideNav: React.FC<{
  activeSlug: string;
  allBlogs: BlogType[];
  onNavigationClick: (blog: BlogType) => void;
  currentCategoryId: string | undefined;
}> = ({ activeSlug, onNavigationClick, currentCategoryId, allBlogs }) => {
  const [blogs, setBlogs] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [mobileNav, setMobileNav] = useState(false);
  const [blogCategories, setBlogCategories] = useState<any[]>([]);

  const onClickNav = (item: BlogType) => {
    onNavigationClick(item);
    setMobileNav(false);
  };

  const sortBlogs = (fetched: BlogType[]) => {
    if (currentCategoryId) {
      return fetched
        .filter((blog) => blog.blogCategoryId === +currentCategoryId)
        .sort(
          (a, b) =>
            new Date(b.dateTimeInEasternTime ?? b.createdAt).getTime() -
            new Date(b.dateTimeInEasternTime ?? a.createdAt).getTime()
        );
    } else
      return fetched.sort(
        (a, b) =>
          new Date(b.dateTimeInEasternTime ?? b.createdAt).getTime() -
          new Date(b.dateTimeInEasternTime ?? a.createdAt).getTime()
      );
  };

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const fetched = await getBlogs();
        if (fetched.length > 0) {
          const sortedBlogs = sortBlogs(fetched);
          setBlogs(sortedBlogs);
          setIsLoading(false);
        }
      } catch {
        setIsLoading(false);
      }
    })();
  }, [currentCategoryId, allBlogs]);

  useEffect(() => {
    const fetchBlogCategories = async () => {
      try {
        const blogCategoryList = await getBlogCategories();
        //sorting as per display order
        blogCategoryList.sort(
          (a, b) =>
            a.blog_category_display_order - b.blog_category_display_order
        );
        setBlogCategories(blogCategoryList);
      } catch (error) {
        console.error("Failed to fetch blog categories:", error);
      }
    };
    fetchBlogCategories();
  }, [currentCategoryId]);

  let selectedBlogCategoryName: string | null = null;
  if (currentCategoryId) {
    selectedBlogCategoryName = blogCategories?.find(
      (item) => item.blog_category_id === +currentCategoryId
    )?.blog_category_name;
  } else {
    selectedBlogCategoryName = null;
  }

  return isLoading ? (
    <StyledLoadingSpinner />
  ) : (
    <div
      className={
        mobileNav ? `challengeLeftNav mobileActive` : "challengeLeftNav"
      }
    >
      <div
        className="mobileNav"
        onClick={() => {
          setMobileNav(!mobileNav);
        }}
      >
        {selectedBlogCategoryName
          ? selectedBlogCategoryName
          : "All Latest Articles"}
      </div>
      {!mobileNav && (
        <div className="navHeading">
          {selectedBlogCategoryName
            ? selectedBlogCategoryName
            : "All Latest Articles"}
        </div>
      )}
      <ul className="itemList">
        {blogs.map((item, index) => {
          return (
            <li className={"expandedItem"} key={index}>
              <ul id={`blog-${index}`}>
                <>
                <li
                  key={`${index}`}
                  className={activeSlug === item.slug ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    onClickNav(item);
                  }}
                >
                  <span className="headingTxt">{item.title}</span>
                  <span>
                    {formatToEasternTime(item.dateTimeInEasternTime) ??
                      formatToET(item.createdAt)}
                  </span>
                </li>
                  {(!mobileNav && index === 0) && (
                  <div className="mediumAdBlk">
                    <AdUnit
                      slot="1086663990"
                      format="rectangle"
                      client="ca-pub-2646617990321066"
                      style={{ display: "block", width: "100%", height: "250px" }}
                    />
                  </div>
                )}
                </>
              </ul>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default BlogDetailsSideNav;
